export function NoMatchingRecords() {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="rounded-full bg-muted p-6 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-12 w-12 text-muted-foreground"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
      </div>
      <h3 className="text-lg font-semibold mb-2">No matching records</h3>
      <p className="text-sm text-muted-foreground text-center max-w-sm">
        Try adjusting your search terms or filters to find what you're looking for.
      </p>
    </div>
  );
}
